import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { IconButton, Tooltip } from '@mui/material';

interface CopyButtonProps {
  text: string;
  tooltipText?: string;
  className?: string;
  size?: 'small' | 'tiny';
}

const CopyButton = ({
  text,
  tooltipText = 'Copy',
  className = '',
  size = 'small',
}: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const buttonSize = size === 'tiny' ? 'small' : 'medium';

  return (
    <Tooltip title={copied ? 'Copied!' : tooltipText} placement="top">
      <IconButton
        onClick={handleCopy}
        size={buttonSize}
        className={className}
        sx={{
          color: copied ? 'success.main' : 'action.active',
          transition: 'color 0.2s',
          padding: size === 'tiny' ? '2px' : undefined,
          '& .MuiSvgIcon-root': {
            fontSize: size === 'tiny' ? '0.875rem' : undefined,
          },
        }}
      >
        {copied ? (
          <CheckIcon fontSize="small" />
        ) : (
          <ContentCopyIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
